<template>
    <div>
        <base-dialog :loading="loading" :value="dialog" :width="480" :title="$t('common.history')" @input="onInput" @close="hide">
            <skeleton-loader v-if="loading" type="rows" />
            <template v-else>
                <div v-if="history.length === 0" class="report-history-empty">
                    {{ $t('common.no_reports_yet') }}
                </div>
                <div v-else class="report-history-list">
                    <button v-for="item in history" :key="item.id" type="button" class="report-history-row"
                        @click="$emit('showReport', { report: item, student })">
                        <span class="report-history-date">{{ item.dateString }}</span>
                        <v-icon size="16">mdi-magnify</v-icon>
                    </button>
                </div>
            </template>
        </base-dialog>
    </div>
</template>

<script>
import { db } from "@/utils/Firebase";
import BaseDialog from './BaseDialog';
import SkeletonLoader from './SkeletonLoader.vue';

export default {
    name: "HistoryReportStudent",
    components: { BaseDialog, SkeletonLoader },
    props: {
        coachId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            student: null,
            history: [],
        }
    },
    computed: {
    },
    methods: {
        show(student = null, isTeam = false) {
            const vm = this
            vm.setDefaults(student, isTeam)
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        onInput(val) {
            if (!val) this.hide()
        },
        reset() {
            const vm = this
            vm.student = ''
            vm.history = []
        },
        async setDefaults(student, isTeam) {
            const vm = this;
            vm.student = student
            await vm.withLoading(async () => {
                const type = isTeam ? 'team' : 'student'
                let hitoryRef = await db.collection('evaluationReports')
                    .where('studentId', '==', vm.student.id)
                    .where('coachId', '==', vm.coachId)
                    .where('type', '==', type)
                    .orderBy('created_at', 'desc')
                    .get()
                vm.history = hitoryRef.docs.map(doc => ({ id: doc.id, ...doc.data(), dateString: vm.$moment(doc.data().date).format('DD/MM/YY') }))
            })
        },
    },
}
</script>

<style scoped>
.report-history-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.report-history-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    padding: 14px 16px;
    border: 1px solid var(--v-outline-base);
    border-radius: 10px;
    background: var(--v-surface-base);
    font-family: inherit;
    font-size: 14px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
    cursor: pointer;
    text-align: left;
    transition: border-color 0.15s, background 0.15s;
}

.report-history-row:hover {
    border-color: var(--v-primary-base);
    background: var(--v-surface2-base);
}

.report-history-row:hover .report-history-date {
    color: var(--v-primary-base);
}

.theme--light .report-history-row:hover {
    border-color: var(--v-accent-base);
}

.theme--light .report-history-row:hover .report-history-date {
    color: var(--v-accent-base);
}

.report-history-row .v-icon {
    color: var(--v-txtMuted-base);
    flex-shrink: 0;
}

.report-history-empty {
    text-align: center;
    font-size: 13px;
    color: var(--v-txtMuted-base);
    padding: 24px 0;
}
</style>
